import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AppBar, DialogActions, DialogContent, Divider, IconButton, Toolbar, Typography } from '@mui/material';
import { FormikProvider } from 'formik';
import { observer } from 'mobx-react-lite';
import { useCallback, useMemo, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { useService } from '~/services/service.base';
import { MediaSearchService } from '~/services/service.media.search';
import { UIService } from '~/services/service.ui';
import { useFormikModel } from '~/tools/formik.model';
import { plainToModel } from '~/tools/plain.model';
import { Button } from '~/views/atoms/button';
import { Icons } from '~/views/atoms/icons';
import { SearchField } from '~/views/molecules/search.field';
import { SimpleSearchModel } from '~/models/simple-search.model';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '~/routes/routes';
const sxToolbar = { height: UIService.TOOLBAR_SEARCH_HEIGHT, justifyContent: 'space-between', gap: 1 };
export const SimpleSearch = observer(() => {
    const { t } = useTranslation();
    const mediaSearchService = useService(MediaSearchService);
    const { searchFieldSvc, openSearchSvc, handleClickBack } = mediaSearchService;
    const navigate = useNavigate();
    const onSubmit = useCallback(() => {
        if (searchFieldSvc.value === undefined) {
            return;
        }
        const searchValue = searchFieldSvc.value;
        mediaSearchService.setQuery(searchFieldSvc.value);
        mediaSearchService.getMediaItems();
        mediaSearchService.openDialogSvc.handleClose();
        mediaSearchService.openSearchSvc.handleClose();
        mediaSearchService.searchFieldSvc.handleClear();
        navigate(ROUTES.FUNDS.MEDIA.SEARCH_RESULT.path, { state: { query: searchValue } });
    }, [mediaSearchService, navigate, searchFieldSvc.value]);
    const initialValues = useMemo(() => plainToModel(SimpleSearchModel, {}), []);
    const formik = useFormikModel(SimpleSearchModel, {
        initialValues,
        onSubmit,
        validateOnMount: true,
        validateOnChange: true,
    });
    return (_jsxs(FormikProvider, { value: formik, children: [_jsxs(AppBar, { color: "inherit", position: "relative", children: [_jsxs(Toolbar, { sx: sxToolbar, children: [_jsx(IconButton, { color: "inherit", onClick: handleClickBack, children: _jsx(Icons.Back, {}) }), !openSearchSvc.open ? (_jsx(SearchField, { searchFieldSvc: searchFieldSvc })) : (_jsxs(Fragment, { children: [_jsx(Typography, { variant: "h2", children: t('SEARCH_DIALOG_INFO_SHEET') }), _jsx(IconButton, { color: "inherit", onClick: searchFieldSvc.handleClear, children: _jsx(Icons.Close, { color: "primary" }) })] }))] }), _jsx(Divider, {})] }), _jsx(DialogContent, { children: !openSearchSvc.open && (_jsx(Button, { type: 'submit', fullWidth: true, color: "inherit", onClick: openSearchSvc.handleOpen, children: t('SEARCH_DIALOG_INFO_SHEET') })) }), _jsx(DialogActions, { children: _jsx(Button, { disabled: !searchFieldSvc.value, fullWidth: true, onClick: formik.submitForm, children: t('SEARCH_DIALOG_SEARCH') }) })] }));
});
